const getDebugModeUrlParams = () => {
  var _a;
  const urlParams = new URLSearchParams(window.location.search);
  const debugUrlParam = urlParams.get("debug");
  const alreadyRecordingUrlParam = urlParams.get("already-recording");
  const larkGroupId = (_a = urlParams.get("groupId")) != null ? _a : "";
  if (larkGroupId) {
    return {
      enableDebug: (debugUrlParam == null ? void 0 : debugUrlParam.toLowerCase()) === "true",
      larkGroupId,
      alreadyRecording: (alreadyRecordingUrlParam == null ? void 0 : alreadyRecordingUrlParam.toLowerCase()) === "true"
    };
  } else {
    return {
      enableDebug: false,
      larkGroupId,
      alreadyRecording: false
    };
  }
};
const removeDebugModeUrlParams = () => {
  const url = new URL(window.location.href);
  url.searchParams.delete("debug");
  url.searchParams.delete("groupId");
  url.searchParams.delete("already-recording");
  window.history.replaceState({}, "", url.toString());
};
export {
  getDebugModeUrlParams,
  removeDebugModeUrlParams
};
